import React from "react";
import PhotoGallery from "./PhotoGallery";
import "./Gallery.css";

const Gallery = () => {
  return (
    <div className="gallery-page">
      <div className="gallery-page-content">
        <div className="gallery-content">
          <PhotoGallery />
        </div>
      </div>
    </div>
  );
};

export default Gallery; 